// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2aeCr","itemTitle":"ClientEmergencyInfo_itemTitle__3hzlx","itemText":"ClientEmergencyInfo_itemText__BIXeB"};